"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationSchema = exports.organizationSchemaReference = exports.organizationIdSchema = void 0;
const zod_1 = require("zod");
const images_schema_1 = require("./images.schema");
const personSchema = __importStar(require("./person.schema"));
exports.organizationIdSchema = zod_1.z.string().uuid().describe("Unique identifier of an organization in the format of UUID");
exports.organizationSchemaReference = zod_1.z
    .object({
    id: exports.organizationIdSchema,
    type: zod_1.z.literal("organization"),
})
    .strict();
exports.organizationSchema = zod_1.z
    .object({
    id: exports.organizationIdSchema,
    name: zod_1.z.string().describe("Organization's preferred full name"),
    officialName: zod_1.z.string().describe("Organization's official name with an unlimited length").optional(),
    shortName: zod_1.z.string().max(25).describe("Organization's short name with max. 25 characters").optional(),
    abbreviation: zod_1.z.string().max(15).describe("Organization's abbreviation with max. 15 characters").optional(),
    sortName: zod_1.z.string().describe("A name to use in a lexicographically ordered list").optional(),
    alternateNames: zod_1.z.array(zod_1.z.string()).describe("Alternate names to use for example in search").optional(),
    images: images_schema_1.imagesSchema.optional(),
    members: zod_1.z.lazy(() => zod_1.z.array(zod_1.z.discriminatedUnion("type", [exports.organizationSchemaReference, personSchema.personSchemaReference])).min(1)).optional(),
})
    .strict()
    .refine((org) => org.shortName || org.abbreviation, {
    message: "Organization must have either shortName or abbreviation",
})
    .describe("Organization is a group of people, for example a political party, a movement, etc.");
